import { biomarkerLibrary } from '../data/biomarkers';
import type { Biomarker, BiomarkerStatus, Goal } from '../types/platform';

export function getPanel(goal: Goal): Biomarker[] {
  return biomarkerLibrary.map(({ pregnancy, longevity, longevityRange, ...rest }) => {
    const useAlt = goal === 'longevity' && longevityRange;
    return {
      ...rest,
      min: useAlt ? longevityRange[0] : rest.min,
      max: useAlt ? longevityRange[1] : rest.max,
      value: goal === 'pregnancy' ? pregnancy : longevity,
    };
  });
}

export function getStatus(b: Biomarker): BiomarkerStatus {
  if (b.value < b.min) return 'low';
  if (b.value > b.max) return 'high';
  return 'optimal';
}

export function getRangeScale(b: Biomarker) {
  const span = b.max - b.min;
  const lo = Math.max(0, b.min - span * 0.5);
  const hi = b.max + span * 0.5;
  const pct = (v: number) => Math.min(100, Math.max(0, ((v - lo) / (hi - lo)) * 100));
  return { value: pct(b.value), start: pct(b.min), end: pct(b.max) };
}

export const statusStyles: Record<BiomarkerStatus, { label: string; text: string; dot: string; border: string }> = {
  low: { label: 'Low', text: 'text-[#f5b454]', dot: 'bg-[#f5b454]', border: 'border-[#f5b454]/30' },
  high: { label: 'High', text: 'text-[#f0788c]', dot: 'bg-[#f0788c]', border: 'border-[#f0788c]/30' },
  optimal: { label: 'In range', text: 'text-[#8fd3b0]', dot: 'bg-[#8fd3b0]', border: 'border-white/10' },
};

export const goalLabels: Record<Goal, string> = {
  pregnancy: 'Pregnant',
  longevity: 'Wellbeing',
};
